import { UserService } from '@app/core/services/user.service';
import { UserType } from '@app/core/utils/user-type';
import { isTrue } from '@util';
import * as R from 'ramda';

export class BaseUserTypeGuard {
  constructor(protected userService: UserService) {
  }

  protected hasPermission(allowedUserTypes: UserType[]): boolean {
    let permissions: boolean[] = [];
    if (R.includes(UserType.APPLICANT, allowedUserTypes)) {
      permissions = R.append(this.userService.isApplicantUser(), permissions);
    }
    if (R.includes(UserType.IM, allowedUserTypes)) {
      permissions = R.append(this.userService.isImUser(), permissions);
    }
    if (R.includes(UserType.COSS, allowedUserTypes)) {
      permissions = R.append(this.userService.isCossUser(), permissions);
    }
    if (R.includes(UserType.ADMIN, allowedUserTypes)) {
      permissions = R.append(this.userService.isAdmin(), permissions);
    }
    if (R.includes(UserType.RNEJO, allowedUserTypes)) {
      permissions = R.append(this.userService.isRneJo(), permissions);
    }
    if (R.includes(UserType.INTEGRATION_PLATFORM, allowedUserTypes)) {
      permissions = R.append(this.userService.isIntegrationPlatform(), permissions);
    }
    return R.any(isTrue, permissions);
  }

}
